import { BUSINESS } from "byzantine/src/dbbl/businessLogic/modules/permissions/constants";
import { hasPermission } from "byzantine/src/dbbl/businessLogic/modules/permissions/utils";

import { useCurrentUser } from "../../../../components/contexts/CurrentUserContext";

import { useTransactionEnrichmentEnabled } from "./useTransactionEnrichmentEnabled";

/**
 * Gates taxonomy correction: transaction_enrichment on (corrections 400 server-side
 * without it), then the same permission `useCanWriteReceipts` checks. Kept separate from
 * useCanWriteReceipts so the ledger does not silently follow a future change made for
 * receipts, which aren't gated on transaction_enrichment.
 *
 * Consumer users have no business permissions; account access is enforced by the backend.
 */
export const useCanWriteTransactions = (): boolean => {
  const { currentUser } = useCurrentUser();
  const transactionEnrichmentEnabled = useTransactionEnrichmentEnabled();
  if (!currentUser || !transactionEnrichmentEnabled) return false;
  if (!currentUser.isBusiness()) return true;
  return hasPermission(
    currentUser.business_permissions,
    BUSINESS.WRITE.TRANSACTION
  );
};
